import { uuid } from 'vue-uuid'
import type { MetaAncestries } from '@@/types/types'

export default defineNuxtPlugin((nuxtApp) => {
  const { $i18n } = nuxtApp as any
  const {
    public: { environment, googleTagManagerCode, nodeEnv },
  } = useRuntimeConfig()
  const route = useRoute()
  const { authenticated, authUserIdTracking } = useAuth()
  const { currency, userType } = useUser()
  const { phoneNumber } = useContactPhoneNumber()
  const { ancestries: destiAncestries, searchDestination } = useDestination()

  const isEnabled = computed(() => {
    // use of a if/else instead of returning directly because of:
    //    ERROR: 'default' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
    // as `useUser` and `useAuth` also consume the `nuxtApp` with `useNuxtApp`
    if (nodeEnv === 'production' && userType.value !== 'admin') return true
    return false
  })

  const { proxy: gtm } = useScriptGoogleTagManager({
    scriptOptions: {
      trigger: isEnabled,
      warmupStrategy: 'preconnect',
    },
    scriptInput: {
      defer: true,
      nonce: uuid.v4(),
      src: `https://load.conversion.lecollectionist.com/apzvvqdl.js?id=${googleTagManagerCode}`,
    },
  })

  useScriptEventPage(() => {
    const ancestries =
      (route.meta.ancestries as MetaAncestries) ?? destiAncestries.value

    dataLayer.value.push({
      event: 'page_view',
      cluster_id: ancestries?.clusterId,
      cluster_name: ancestries?.clusterName,
      country_id: ancestries?.countryId,
      country_name: ancestries?.countryName,
      currency: currency.value,
      destination_id: ancestries?.destinationId,
      destination_name: ancestries?.destinationName,
      locale: $i18n.locale.value,
      logged_in: authenticated.value,
      page_type: pageType.value,
      user_lc_id: authUserIdTracking.value,
      user_type: userType.value,
      lc_phone_number:
        environment === 'production' ? phoneNumber.value.slice(1) : undefined,
    })
  })

  const dataLayer = computed(() =>
    isEnabled.value
      ? gtm.dataLayer
      : {
          push: ({
            event,
            ...props
          }: Record<string, unknown> & { event: string }) =>
            console.log(
              '[GTM] Dispatching event %s with properties %O',
              event,
              props,
            ),
        },
  )

  const pageType = computed(
    () =>
      (route.meta?.gtmAdditionalEventData as Record<string, string> | undefined)
        ?.page_type ||
      (searchDestination.value
        ? getTrackViewPageType(searchDestination.value)
        : 'other'),
  )

  return { provide: { gtm: { dataLayer, pageType } } }
})
